"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackAdWordsParams = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackAdWordsParams(cartOrOrder) {
    const items = cartOrOrder.items;
    const ecommProdid = items.flatMap(item => {
        const prodIds = Array(item.quantity).fill(item.product.trackingName);
        if ('packaging' in item && item.packaging) {
            const packagingTitle = item.packaging.title;
            if (packagingTitle) {
                prodIds.push(...Array(item.quantity).fill(packagingTitle));
            }
        }
        else if ('selectedPackaging' in item && item.selectedPackaging) {
            const packagingTitle = item.selectedPackaging.title;
            prodIds.push(...Array(item.quantity).fill(packagingTitle));
        }
        return prodIds;
    });
    (0, pushToDataLayer_1.pushToDataLayer)({
        AdWordsParams: {
            ecommProdid,
            ecommTotalvalue: cartOrOrder.total.gross.amount,
        },
    });
}
exports.trackAdWordsParams = trackAdWordsParams;
//# sourceMappingURL=trackAdWordsParams.js.map